import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { InstagramAccountsQuery, InstagramAccountsQueryVariables } from './__generated__/InstagramAccountsQuery';

const INSTAGRAM_ACCOUNTS_QUERY = gql`
  query InstagramAccountsQuery($facebookPageIds: [String!]!) {
    instagramAccounts(facebookPageIds: $facebookPageIds) {
      facebookPageId
      accounts {
        type
        id
      }
      errors
    }
  }
`;

export const instagramAccountsQuery = (variables: InstagramAccountsQueryVariables) => {
  return kmsClient.query<InstagramAccountsQuery, InstagramAccountsQueryVariables>({
    query: INSTAGRAM_ACCOUNTS_QUERY,
    variables,
    fetchPolicy: 'network-only'
  });
};

export const useInstagramAccountsLazyQuery = () => {
  return useLazyQuery<InstagramAccountsQuery, InstagramAccountsQueryVariables>(INSTAGRAM_ACCOUNTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
